import { PayInvoiceMutation } from './pay-invoice-mutation';
import { SubscriptionStatusQuery } from './subscription-status-query';
export var endpoints = {
    subscriptionStatusQuery: new SubscriptionStatusQuery(),
    payInvoiceMutation: new PayInvoiceMutation(),
};
